
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { Parcel } from "./types";
import { processParcel } from "./utils";

/**
 * Hook to fetch all parcels for the current user
 */
export const useParcels = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['parcels'],
    queryFn: async () => {
      if (!user) {
        throw new Error("Utilisateur non authentifié");
      }

      const { data, error } = await supabase
        .from('parcels')
        .select('*')
        .eq('user_id', user.id);

      if (error) throw error;

      // Process each parcel to extract coordinates
      return data.map(parcel => processParcel(parcel)) as Parcel[];
    },
    enabled: !!user,
  });
};
